import React from "react";
import Layout from "../../Layout";
import HeaderUser from "../HeaderUser";
import { Link } from "react-router-dom";

const SuccessRegistration = () => (
  <Layout>
    <HeaderUser />
    <section className="layout-container">
      <div className="container ctr">
        <div className="bi-success-check">
          <i className="bi bi-check2-circle" alt="Success Checkmark"></i>
        </div>
        <div className="lg-msg">
          User have been added successfully.
        </div>
        <div className="text-size6 spacer-margin3">
          An email has been sent to the contact address with the new username and a temporary password. To register additional users, click the button below to return to the registration page.
        </div>
        <Link
          to={"/user-registration"}
          className="btn btn-primary"
          role="button"
          aria-labelledby="Add Organization"
        >
          Add Users
        </Link>
            </div>
        </section>
  </Layout>
);

export default SuccessRegistration;
